var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-box"},[_c('div',{staticClass:"submit-btn",class:{'can-submit-btn':_vm.submitFlag},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.subText || _vm.$t('public.submitMessage')))]),(_vm.btnRemark)?_c('p',{staticClass:"remark"},[_vm._v(_vm._s(_vm.btnRemark))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }